import React from 'react';
import DefaultAppBar from "./AppBar";
import {Box, Grid, Typography} from "@mui/material";
import Forest1 from './images/forest1.jpg';
import DefaultFooter from "./DefaultFooter";
import useMediaQuery from "@mui/material/useMediaQuery";

const KeyText = (props) => {
    return (
        <Typography variant="body1"
                    style={{
                        fontSize: '20px',
                        fontWeight: '500',
                        letterSpacing: '.03rem',
                        lineHeight: '1.7rem',
                        color: 'inherit',
                        textDecoration: 'none',
                    }}>
            {props.children}
        </Typography>
    );
}

const ValueText = (props) => {
    return (
        <Typography variant="body1"
                    style={{
                        fontSize: '20px',
                        fontWeight: '300',
                        letterSpacing: '.03rem',
                        lineHeight: '1.7rem',
                        color: 'inherit',
                        textDecoration: 'none',
                    }}>
            {props.children}
        </Typography>
    );
}


const Impressum = () => {
    const isDesktop = useMediaQuery('(min-width:900px)');
    return (
        <Box className="Impressum" height='100%'>
            <DefaultAppBar fixed={false}/>
            <img src={Forest1} alt='Forest' style={{
                display: "block",
                width: "100%",
                height: "36em",
                objectFit: "cover",
                objectPosition: "center",
                // backgroundImage: `url(${Forest1})`,
                // backgroundImage: `linear-gradient(to bottom, rgba(255, 255, 255, 0) 95%, rgba(255, 255, 255, 1) 100%), url(${Forest1})`,
            }}/>
            <Box my='48px' position='absolute' width='100%' sx={{
                zIndex: 2,
                top: '5%',
            }}>
                <Box>
                    <Box position='relative' mx='16px' py='48px'>
                        <Typography variant="h3"
                                    style={{
                                        flex: 1,
                                        textAlign: "center",
                                        color: "white",
                                        fontWeight: "400",
                                        fontSize: "4em",
                                        margin: "0.5em",
                                        fontFamily: "Raleway",
                                        textShadow: "0 0 0.15em rgba(0,0,0,0.75)",
                                        userSelect: "none"
                                    }}>Nehmen Sie Kontakt auf</Typography>
                    </Box>
                    <Box sx={{display: 'flex', justifyContent: 'center'}}>
                        <Box position='relative' mx='24px' p='36px' maxWidth='800px' sx={
                            {
                                backgroundColor: 'rgba(255, 255, 255, 1)',
                                borderRadius: '8px',
                                boxShadow: '0px 0px 16px rgba(0, 0, 0, 0.5)',
                            }
                        }>
                            <Typography variant="h3">Impressum</Typography>
                            <Box my='36px'></Box>
                            {isDesktop && <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <KeyText>Name </KeyText><ValueText>Leopold Keiblinger</ValueText>
                                </Grid>
                                <Grid item xs={6}>
                                    <KeyText>Telefon</KeyText><ValueText><a href="tel:+43 664 7608664">+43 664
                                    7608664</a></ValueText>
                                </Grid>
                                <Grid item xs={6}>
                                    <KeyText>Adresse</KeyText><ValueText>Waldweg 1</ValueText>
                                    <ValueText>3202 Hofstetten</ValueText>
                                    <ValueText>Österreich</ValueText>
                                </Grid>
                                <Grid item xs={6}>
                                    <KeyText>E-Mail </KeyText><ValueText><a
                                    href="mailto: kontakt@keiblinger-saegetechnik.at">office@keiblinger-saegetechnik.at</a></ValueText>
                                </Grid>
                                <Grid item xs={6}>
                                    <KeyText>UID</KeyText><ValueText>ATU61871255</ValueText>
                                </Grid>
                            </Grid>}
                            {!isDesktop && <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <KeyText>Name </KeyText><ValueText>Leopold Keiblinger</ValueText>
                                </Grid>
                                <Grid item xs={12}>
                                    <KeyText>Adresse</KeyText><ValueText>Waldweg 1</ValueText>
                                    <ValueText>3202 Hofstetten</ValueText>
                                    <ValueText>Österreich</ValueText>
                                </Grid>
                                <Grid item xs={12}>
                                    <KeyText>UID</KeyText><ValueText>ATU61871255</ValueText>
                                </Grid>
                                <Grid item xs={12}>
                                    <KeyText>Telefon</KeyText><ValueText><a href="tel:+43 664 7608664">+43 664
                                    7608664</a></ValueText>
                                </Grid>
                                <Grid item xs={12}>
                                    <KeyText>E-Mail </KeyText><ValueText><a
                                    href="mailto: kontakt@keiblinger-saegetechnik.at">office@keiblinger-saegetechnik.at</a></ValueText>
                                </Grid>
                            </Grid>}
                        </Box>
                    </Box>
                </Box>
                <Box my='18px'/>
                <DefaultFooter/>
            </Box>
        </Box>
    );
}

export default Impressum;
